import React from "react";
import CountDownTimerVisibilityAware from "../CountDownTimer/CountDownTimerVisibilityAware";
import { useCalculateDiscountEndTime } from "../../hooks/useCalculateDiscountEndTime";

export default function PopBannerRender(props) {
  // PROPS COMING FROM PopBanner
  const {
    refPop,
    pop,
    transition,
    intentPopOpen,
    handleClosePops,
    handleYesButton,
    discountCodeState,
    isDiscountValid,
    remainingTime,
    offerRemainingTime,
    discountAmount,
    setExitPopOpen,
  } = props;

  const displayDate = useCalculateDiscountEndTime(offerRemainingTime);

  return (
    <>
      {!isDiscountValid && (remainingTime <= 0 || !remainingTime) && (
        <div className="pop-modal-background">
          <div
            ref={refPop}
            style={pop.modalFront}
            className={
              transition
                ? "pop-modal-front pop-modal-front-active rad5r col"
                : intentPopOpen
                  ? "pop-modal-front rad5r col"
                  : "pop-modal-front-active rad5r col"
            }
          >
            <div style={pop.contentDiv}>
              <ul className="w95p row beddo-border-bottom">
                <li>
                  <img
                    className="w3r"
                    src="/images/beddo-mern-logo.png"
                    alt="beddo logosu - beddo senin huzur senin"
                  />
                </li>
                <li>
                  <i
                    className="fas fa-times fs125 beddo-color pointer"
                    title="Kapat"
                    onClick={() => handleClosePops()}
                  ></i>
                </li>
              </ul>
              <h1 className="beddo-border-bottom-5" style={pop.title.style}>
                {pop.title.content}
              </h1>
              {pop.popImage && pop.popImage.content.length > 0 && (
                <img
                  style={pop.popImage.style}
                  src={pop.popImage.content}
                  alt="beddo™ İndirimler"
                />
              )}
              {discountAmount && pop.generateInstantDiscount && (
                <h2 className="fs2 sans-serif bold-font">
                  {discountAmount} TL İndiriminiz Hazır
                </h2>
              )}
              {pop.displayCountDownTimer && (
                <>
                  <CountDownTimerVisibilityAware
                    milliseconds={offerRemainingTime}
                    setExitPopOpen={setExitPopOpen}
                    location={"PopBannerRender"}
                  />
                  {offerRemainingTime > 86400000 && (
                    <p className="lightredbck padh fs15">
                      İndirim Bitiş Tarihi : {displayDate}
                    </p>
                  )}
                </>
              )}
              <div style={pop.paragraphDiv}>
                {pop.generateDiscountCode && (
                  <div className="w40p beddo-border-dashed-3 lightbck marupside1-5">
                    <h2 className="fs15 red-col txtcenter marupside1-5">
                      Dikkat: Şu andan itibaren{" "}
                      <span className="bold-font">{pop.discountExpiry}</span>{" "}
                      dakika geçerlidir
                    </h2>
                    <h2 className="txtcenter" style={pop.title.style}>
                      {discountCodeState}
                    </h2>
                    <h3 className="fs3 txtcenter">
                      <span className="beddo-border-bottom">
                        {discountAmount} TL Değerindedir
                      </span>
                    </h3>
                  </div>
                )}

                {pop.paragraphTitle.content.map((content, index) => (
                  <h3 key={index + 100} style={pop.paragraphTitle.style}>
                    {content}
                  </h3>
                ))}
              </div>

              <ol>
                {pop.paragraph.content.map((content, index) => (
                  <li key={index + 200} style={pop.paragraph.style}>
                    <i className="fas fa-check green marq"></i>
                    {content}
                  </li>
                ))}
              </ol>

              {!pop.generateDiscountCode && (
                <div style={pop.buttonDiv}>
                  {pop.buttonYes && (
                    <button
                      type="button"
                      style={pop.buttonYes.style}
                      onClick={() => handleYesButton(discountAmount)}
                    >
                      {pop.buttonYes.content}
                    </button>
                  )}
                  {pop.buttonNo && (
                    <button
                      type="button"
                      style={pop.buttonNo.style}
                      onClick={() => handleClosePops()}
                    >
                      {pop.buttonNo.content}
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
